import ConsultSection from "../PageElements/HomePageElements/ConsultSection";
import OverviewMainSection from "../PageElements/OverviewPageElements/OverviewMainSection";
// import OverviewMainSection from "../PageElements/OverviewPageElement/OverviewMainSection";


export default function Overviews() {
    return (
        <>

            <OverviewMainSection/>
            <ConsultSection/>
            
        </>
    )
}